export default __webpack_public_path__ + "static/media/selected3.c7a450ff.png";